import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import hljs from "highlight.js";
hljs.configure({ ignoreUnescapedHTML: true });

@Component({
  selector: "app-code-snippet",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./code-snippet.component.html",
  styleUrl: "./code-snippet.component.scss",
})
export class CodeSnippetComponent {
  @Input() title: string = "";
  @Input() code: string = "";
  @Input() displayAsCard = false;

  formattedCode: string = "";

  ngOnChanges() {
    this.highlightCode();
  }

  private highlightCode() {
    const highlighted = hljs.highlightAuto(this.code).value;
    const lines = highlighted.split("\n").map((line) => {
      if (line.trim().startsWith("-")) {
        return `<div class="line-removed">${line}</div>`;
      }
      if (line.trim().startsWith("+")) {
        return `<div class="line-added">${line}</div>`;
      }
      return `<div>${line}</div>`;
    });

    this.formattedCode = lines.join("");
  }
}
